import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function get (id) {
  return sessaoFetchLoading(`consig`, `/avisos/${id}`)
}
export async function getAvisos (dados) {
  return sessaoFetchLoading(`consig`, `/avisos?` + serialize(dados), 'GET')
}
export async function add (dados) {
  return sessaoFetchLoading(`consig`, `/avisos`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`consig`, `/avisos`, 'PUT', dados)
}
export async function del (dados) {
  return sessaoFetchLoading(`consig`, `/avisos/${dados}`, 'DELETE')
}
export async function getByUsuario (dados) {
  return sessaoFetchLoading(`consig`, `/avisos/listar`)
}
export async function marcarComoLido (dados) {
  return sessaoFetchLoading(`consig`, `/avisos/MarcarComoLido`, 'PUT', dados)
}
export async function naoLido () {
  return sessaoFetchLoading(`consig`, `/avisos/PrimeiroNaoLido`)
}



// WEBPACK FOOTER //
// ./src/api/aviso.js